<ng-container [ngSwitch]="loading">
  <div
    *ngSwitchCase="true"
    class="d-flex justify-content-center align-items-center h-100">
    <app-loader></app-loader>
  </div>

  <ng-container *ngSwitchCase="false">
    <router-outlet></router-outlet>
    <lib-notifications></lib-notifications>
  </ng-container>
</ng-container>
